import axios from 'axios';
import qs from "qs";
//自动切换环境
let baseUrl = '';

if (process.env.NODE_ENV == 'development'||process.env.NODE_ENV == 'production'||process.env.NODE_ENV == 'development1') {
    baseUrl = process.env.VUE_APP_BASEURL;
    // baseUrl = "/link/"
} else {
    baseUrl = "/link/"
}
axios.defaults.baseURL = baseUrl    

export default {
    /**
     * get 请求
     * @param url 接口路由
     * @param auth 是否需要带登录信息
     * @returns {AxiosPromise<any>}
     */
    get(url, params, auth = false) {
        if (auth) {
            if (params) {
                return axios.get(url, {
                    params: params,
                    headers: {
                        Authorization: ''
                    }
                });
            } else {
                return axios.get(url, {
                    headers: {
                        Authorization: ''
                    }
                });
            }
        } else {
            if (params) {
                return axios.get(url, {
                    params: params,
                    headers: {
                        Authorization: ''
                    },
                });
            } else {
                return axios.get(url);
            }

        }
    },
    // 传递数组方法
    getArray(url, params, auth = false) {
        if (auth) {
            if (params) {
                return axios.get(url, {
                    params: params,
                    paramsSerializer: params => {
                        return qs.stringify(params, {
                            indices: false
                        })
                    },
                    headers: {
                        Authorization: ''
                    }
                });
            } else {
                return axios.get(url, {
                    headers: {
                        Authorization: ''
                    }
                });
            }
        } else {
            if (params) {
                return axios.get(url, {
                    params: params,
                    paramsSerializer: params => {
                        return qs.stringify(params, {
                            indices: false
                        })
                    },
                    headers: {
                        Authorization: ''
                    },
                });
            } else {
                return axios.get(url);
            }
        }
    },
    dowImgGet(url, params, auth = false) {
        return axios.get(url, {
            params: params,
            responseType: 'arraybuffer'
        });
    },
    dowBlodGet(url, params, auth = false) {
        return axios.get(url, {
            params: params,
            paramsSerializer: params => {
                return qs.stringify(params, { indices: false })
                },
            responseType: 'blob'
        });
    },
    dowBlodPost(url, data, auth = false) {
        return axios.post(url, data, {
            responseType: 'blob'
        });
    },
    // dowGet(){
    //     .then(response => {
    //         resolve('data:image/png;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')))
    //         // eslint-disable-next-line handle-callback-err
    //       }).catch((err) => {
    //         reject(new Error('图片下载失败！'))
    //       })
    // },

    /**
     * post 请求
     *
     * @param url 接口路由
     * @param data 接口参数
     * @param auth 是否需要带登录信息
     * @returns {AxiosPromise<any>}
     */
    post(url, data, auth = false) {

        if (auth) {
            return axios.post(url, data, {
                headers: {
                    Authorization: ''
                }
            });
        } else {
            return axios.post(url, data);
        }
    },

    /**
     * put请求
     * @param url 接口路由
     * @param data 接口参数
     * @param auth 是否需要带登录信息
     * @returns {AxiosPromise<any>}
     */
    put(url, data, auth = false) {
        if (auth) {
            return axios.put(url, data, {
                headers: {
                    Authorization: 'Your back-end user authenticates information'
                }
            });
        } else {
            return axios.put(url, data);
        }
    },

    /**
     * 删除
     * @param url 接口路由
     * @param auth 是否需要带登录信息
     * @returns {AxiosPromise}
     */
    del(url, auth = false) {
        if (auth) {
            return axios.delete(url, {
                headers: {
                    Authorization: 'Your back-end user authenticates information'
                }
            });
        } else {
            return axios.delete(url);
        }
    },

    /**
     * 上传文件
     * @param url 接口路由
     * @param file 接口文件
     * @param auth 是否需要带登录信息
     */
    /*  uploader(url, file, auth = false) {
         let param = new FormData();
         param.append('file', file)
         if (auth) {
             return axios.post(url, param, {headers: {Authorization: 'Your back-end user authenticates information'}})
         } else {
             return axios.post(url, param)
         }
     }, */
}